"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledSkeletonCard = require("./styled-skeleton-card");
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function SkeletonCardComponent() {
  return /*#__PURE__*/_react["default"].createElement(_styledSkeletonCard.SkeletonCard, null, /*#__PURE__*/_react["default"].createElement(_styledSkeletonCard.SkeletonImg, null), /*#__PURE__*/_react["default"].createElement(_styledSkeletonCard.SkeletonBrand, null), /*#__PURE__*/_react["default"].createElement(_styledSkeletonCard.SkeletonTitle, null), /*#__PURE__*/_react["default"].createElement(_styledSkeletonCard.SkeletonPrice, null));
}
var _default = exports["default"] = SkeletonCardComponent;